import { Component, Inject, OnDestroy } from '@angular/core';
import { RoutingConfigService, RoutingService, UrlModule, I18nModule } from 'haba-core';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckoutDataService, ProceedService } from '@app/features/checkout';
import { CheckoutStep } from 'haba-featurelibs/checkout/root';
import {
  CheckoutProgressComponent as CxCheckoutProgressComponent,
  CheckoutStepService,
} from 'haba-featurelibs/checkout/components';
import { NgIf, NgTemplateOutlet, NgFor, AsyncPipe } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-checkout-progress',
  templateUrl: './checkout-progress.component.html',
  styleUrls: ['./checkout-progress.component.scss'],
  imports: [
    NgIf,
    RouterLink,
    NgbTooltip,
    NgTemplateOutlet,
    NgFor,
    AsyncPipe,
    UrlModule,
    I18nModule,
  ],
})
export class CheckoutProgressComponent extends CxCheckoutProgressComponent implements OnDestroy {
  private isExpressCheckout: boolean;
  private subscription: Subscription = new Subscription();

  constructor(
    protected checkoutStepService: CheckoutStepService,
    private routingService: RoutingService,
    private proceedService: ProceedService,
    private checkoutDataService: CheckoutDataService,
    private routingConfigService: RoutingConfigService,
    private router: Router
  ) {
    super(checkoutStepService);
    this.subscription = this.checkoutDataService.checkoutData$.subscribe(
      ({ paymentDetails }) => (this.isExpressCheckout = paymentDetails?.expressCheckout)
    );
  }

  public changeStep(clickedStep: CheckoutStep, index: number): void {
    const currentStepIndex = this.checkoutStepService.allSteps.findIndex((step) => {
      const currentUrl = `/${this.routingConfigService.getRouteConfig(step.routeName).paths?.[0]}`;
      return this.router.url.includes(currentUrl);
    });
    const nextStepIndex = this.checkoutStepService.allSteps.findIndex(
      (step) => step.id === clickedStep.id
    );

    // don't do a check if we go back on the steps list
    if (nextStepIndex <= currentStepIndex) {
      this.routingService.go({ cxRoute: clickedStep.routeName });
      return;
    }

    this.proceedService.canProceed().then((value) => {
      if (value) {
        this.routingService.go({ cxRoute: clickedStep.routeName });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
